import { a as getPriceRange } from "../../../../chunks/utils.js";
import { j as json } from "../../../../chunks/index2.js";
const GET = () => {
  return json(getPriceRange());
};
export {
  GET
};
